// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sidebar__attribute[data-v-4be43a91] {\n    margin: 0 0 8px 0;\n    line-height: 1.1;\n    word-break: break-all;\n}\n.sidebar__value[data-v-4be43a91] {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.1;\n    padding-bottom: 16px;\n    word-break: break-all;\n}\n.sidebar__edit-btn[data-v-4be43a91] {\n    display: inline-flex;\n}\n", ""]);
// Exports
module.exports = exports;
